export default class PostsBlock {
	constructor(settings) {
		this.tileAreaId = settings.tileAreaId;
		this.tileArea = document.getElementById(this.tileAreaId);
		this.itemsLoaded = settings.initialItemCount;
		this.pagesLoaded = 0;
		this.currentPagePath = window.location.pathname.replace(/\//g, '');
		this.currentPageKey = 0;
		this.lastTagPage = '';
		this.singlePostHistory = '';
		this.loadMoreHistoryValue = 0;
		this.pageType = '';
		this.loadMoreType = '';

		// Load More
		if (settings.loadMoreItems) {
			this.loadMoreItems = settings.loadMoreItems;
			this.maxLoadMorePages = settings.maxLoadMorePages;
			this.queryData = settings.queryData;
			this.loadMoreButton = document.querySelector(settings.loadMoreButtonSelector);
			if (this.loadMoreButton.getAttribute('id') === 'post-loadmore' || this.loadMoreButton.getAttribute('id') === 'term-loadmore') {
				this.loadMoreButton.addEventListener('click', () => { this.getMorePosts(); });
			} else if (this.loadMoreButton.getAttribute('id') === 'video-loadmore') {
				this.queryData.load_post_type = 'video';
				this.loadMoreButton.addEventListener('click', () => { this.getMorePosts(); });
			}
		}
		PostsBlock.domEvents();

		// Load More History only if post/gallery/archive pages.
		if (document.body.classList.contains('single')) {
			this.pageType = 'single';
			this.initLoadMoreHistory();
		} if (document.body.classList.contains('archive') || document.body.classList.contains('page-template-template-shows-hosts-php')) {
			this.pageType = 'archive';
			this.initLoadMoreHistory();
		}
		const urlParams = new URLSearchParams(window.location.search);
		const page = urlParams.get('pageno');
		if (page && page > 1 && document.body.classList.contains('page-template-template-shows-hosts-php')) {
			this.getMorePosts(page, false, false, true);
		}
	}

	getMorePosts(index = 1, reload = false, increment = true, initial = false) {
		this.tileArea.classList.add('loading');
		this.queryData.posts_per_page = this.getLoadMoreItemAmount();
		const newParams = new URLSearchParams(window.location.search);
		const page = newParams.has('pageno') ? (newParams.get('pageno') * 1) : 1;
		// eslint-disable-next-line max-len
		this.queryData.offset = (this.queryData.posts_per_page * (increment ? page + 1 : page) - this.queryData.posts_per_page);
		if (initial) {
			this.queryData.offset = 0;
			this.queryData.posts_per_page *= page;
		}
		if (this.queryData.load_post_type === 'video') {
			this.queryData.videos_per_page = this.getLoadMoreItemAmount();
		}
		const url = new URL(window.location);
		const newUrl = new URL(`${url.origin}${url.pathname}?pageno=${(increment ? page + 1 : page)}`);
		window.history.pushState(null, null, newUrl);

		const params = `?${PostsBlock.encodeData(this.queryData)}`;
		window.fetch(`/wp-json/slice/post-items/${params}`).then(
			(response) => {
				response.json().then(
					(data) => {
						this.appendPosts({ ...data, initial });
						this.currentPageKey += 1;
						if (index > this.currentPageKey && reload === true) {
							this.getMorePosts(index, true);
						}
					},
					(reason) => this.errorState(reason),
				);
			},
			(reason) => this.errorState(reason),
		);

		this.tileArea.classList.remove('loading');
	}

	appendPosts(data) {
		const initialPos = window.pageYOffset;
		if (data.initial) {
			this.tileArea.innerHTML = data.markup;
		} else {
			this.tileArea.insertAdjacentHTML('beforeend', data.markup);
		}
		this.tileArea.setAttribute('data-more-items', data.more_items);
		this.tileArea.setAttribute('data-no-items', data.total === 0);
		if (this.queryData.load_post_type === 'video') {
			this.itemsLoaded += this.queryData.videos_per_page;
		}
		const adBlocks = document.querySelectorAll('div.posts-block-ad.not-rendered, div.native-ads.not-rendered');
		adBlocks.forEach((block) => {
			Array.from(block.querySelectorAll('script')).forEach((oldScript) => {
				const newScript = document.createElement('script');
				Array.from(oldScript.attributes)
					.forEach((attr) => newScript.setAttribute(attr.name, attr.value));
				newScript.appendChild(document.createTextNode(oldScript.innerHTML));
				oldScript.parentNode.replaceChild(newScript, oldScript);
			});
			block.classList.remove('not-rendered');
		});
		this.itemsLoaded += this.queryData.posts_per_page;
		this.pagesLoaded += 1;

		this.loadMoreHistoryValue = this.pagesLoaded;
		window.sessionStorage.setItem('loadMoreHistoryValue', this.loadMoreHistoryValue);

		if (this.maxLoadMorePages && this.pagesLoaded >= this.maxLoadMorePages) {
			this.tileArea.setAttribute('data-max-pages', 'true');
		}
		if (initialPos) {
			window.history.initialPos = initialPos;
		}
	}

	static errorState(reason) {
		console.log(`Load More Error: ${reason}`);
	}

	getLoadMoreItemAmount() {
		return this.loadMoreItems;
	}

	static encodeData(data) {
		return Object.keys(data).map((key) => [key, data[key]].map(encodeURIComponent).join('=')).join('&');
	}

	static domEvents() {
		// Hover state activated on a post's title when the image has mouse over.
		const featuredImagesLinks = document.querySelectorAll('.posts-block-item__featured-image a');
		if (featuredImagesLinks.length > 0) {
			featuredImagesLinks.forEach((a) => {
				a.addEventListener('mouseover', () => {
					const titleLink = a.parentElement.parentElement.querySelector('.posts-block-item__title a');
					titleLink.classList.add('hover');
				});
				a.addEventListener('mouseout', () => {
					const titleLink = a.parentElement.parentElement.querySelector('.posts-block-item__title a');
					titleLink.classList.remove('hover');
				});
			});
		}
	}

	/**
	 * Load More History Functions
	 *
	 */

	initLoadMoreHistory() {
		this.initSessionStorage(this.pageType);

		if (this.pageType === 'single') {
			this.singlePostLoadMoreHistory();
		}

		if (this.pageType === 'archive') {
			this.archiveLoadMoreHistory();
		}
	}

	initSessionStorage(pageType) {
		const singlePostHistory = window.sessionStorage.getItem('singlePostHistory');
		const lastTagPage = window.sessionStorage.getItem('lastTagPage');
		const loadMoreHistoryValue = window.sessionStorage.getItem('loadMoreHistoryValue');

		if (!singlePostHistory) { // Single Post history was never saved before.
			window.sessionStorage.setItem('singlePostHistory', '');
		} else {
			this.singlePostHistory = singlePostHistory;
		}

		if (!lastTagPage) { // Last Tag page was never saved before.
			window.sessionStorage.setItem('lastTagPage', '');
		} else {
			this.lastTagPage = lastTagPage;
		}

		if (!loadMoreHistoryValue) { // The load More history was never saved before.
			window.sessionStorage.setItem('loadMoreHistoryValue', 0);
		} else {
			this.loadMoreHistoryValue = loadMoreHistoryValue;
		}

		switch (pageType) {
		case 'single':
			// Since this is the single post (article/gallery) , then run the singlePostEvents.
			PostsBlock.singlePostEvents();
			break;

		case 'archive':
			// Since this is the single archive (tag/author) , then save the
			// lastTagPage sessionStorage item to the currentPage's path.
			window.sessionStorage.setItem('lastTagPage', this.currentPagePath);
			console.log(this.loadMoreHistoryValue);
			break;

		default: // it's neither nor, so do not do anything.
		}
	}

	singlePostLoadMoreHistory() {
		window.removeEventListener('beforeunload', this.archiveEvents);
		window.addEventListener('beforeunload', this.singlePostEvents);
	}

	archiveLoadMoreHistory() {
		window.removeEventListener('beforeunload', this.singlePostEvents);
		window.addEventListener('beforeunload', this.archiveEvents);

		const currentPagePath = window.location.pathname.replace(/\//g, '');
		const singlePostHistory = window.sessionStorage.getItem('singlePostHistory').toString();

		if (singlePostHistory !== '' && singlePostHistory === currentPagePath && this.loadMoreButton) {
			// User has just come from a single post, and the last tag page
			// they were browsing is the CURRENT tag page.
			this.getMorePosts(this.loadMoreHistoryValue, true);
		}
	}

	static singlePostEvents() {
		// Only save the singlePostHistory if the lastTagPage was saved
		// ( detects a previous history on the tag page ).
		const lastTag = window.sessionStorage.getItem('lastTagPage').toString();
		if (lastTag !== '') {
			window.sessionStorage.setItem('singlePostHistory', lastTag);
		}
	}

	archiveEvents() {
		// Saves the lastTagPage in the sessionStorage, to be detected later.
		const currentPagePath = window.location.pathname.replace(/\//g, '');
		window.sessionStorage.setItem('lastTagPage', currentPagePath);
		if (typeof this.updateLoadMoreHistoryValue === 'function') {
			this.updateLoadMoreHistoryValue();
		}
	}

	updateLoadMoreHistoryValue() {
		if (parseInt(this.loadMoreHistoryValue, 10) < 1) {
			window.sessionStorage.setItem('loadMoreHistoryValue', '');
		} else {
			window.sessionStorage.setItem('loadMoreHistoryValue', this.loadMoreHistoryValue);
		}
	}
}
